import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { Box, Skeleton, useTheme } from "@mui/material"
import { PieAmchartSeeker } from "@ui-seeker/core"

import { TitleWithPopover } from "@components"
import { useLostBuyBoxOverviewShareReasonChartsData } from "../@hooks"


const HEIGHT = 250

export default function ReasonShare() {

	const { isLoadingReasonCharts, reasonChartsData } = useLostBuyBoxOverviewShareReasonChartsData()

	if (isLoadingReasonCharts) return <Skeleton variant="rectangular" height={HEIGHT} />
	if (!reasonChartsData?.reasonData?.length) return <></>

	return <Box>
		<PieAmchartSeeker
			rootID="ReasonShare"
			data={reasonChartsData?.reasonData}
			title={<TitleWithPopover title="Share of Reasons for Losing the Buy Box" />}
			series={[{
				yField: 'reason',
				xField: "num",
				innerRadius: 60,
			}]}
			sx={{ height: HEIGHT }}
			chartProps={{
				startAngle: 180,
  				endAngle: 360,
				enabledPDF: false,
				root: {
					colors: reasonChartsData?.reasonDataColors
				},
				chart: {
					horizontalLayout: true,
				},
				legend: {
					centerY: 50,
					y: 50,
					verticalLayout: true,
					labels: {
						maxWidth: 140,
						width: 140,
						oversizedBehavior: "wrap"
					},
					valueLabels: {
						textAlign: "right"
					}
				}
			}}
		/>
	</Box>
}